// extracted by mini-css-extract-plugin
export default {"linkGrid":"LinkGrid_linkGrid__si3Vb","gridItem":"LinkGrid_gridItem__PEl0C","isSmall":"LinkGrid_isSmall__0Fd2F","isMedium":"LinkGrid_isMedium__2MnGT"};